export default __webpack_public_path__ + "static/media/product.64621a9f.svg";